export const DEFINITION_URLS = {
  gaugeBody: 'gauge-assets-body',
  gaugeFairValueBody: 'gauge-fair-value-body',
  gaugeFairValueFillBad: 'gauge-fair-value-fill-bad',
  gaugeFairValueFillGood: 'gauge-fair-value-fill-good',
  gaugeFairValueRightOverflow: 'gauge-fair-value-right-overflow',
  gaugeFairValueLeftOverflow: 'gauge-fair-value-left-overflow',
  gradientId: 'gauge-assets-gradient',
  largePin: 'gauge-assets-large-pin',
  xLargePin: 'gauge-assets-xLarge-pin',
  mediumPin: 'gauge-assets-medium-pin',
  smallPin: 'gauge-assets-small-pin',
  actualBackgroundGradient: 'url(#ActualBackgroundGradient)',
  yearMarkerGradient: 'url(#YearMarkerGradient)',
  chartFailPattern: 'url(#Chart_Fail_Pattern)',
  chartFailPatternInverse: 'url(#Chart_Fail_Pattern_Inverse)',
  noirGradient01: 'url(#Noir_Gradient_01)',
  noirGradient02: 'url(#Noir_Gradient_02)',
  chart01Gradient01: 'url(#Chart_01_Gradient_01)',
  chart01Gradient02: 'url(#Chart_01_Gradient_02)',
  chart02Gradient01: 'url(#Chart_02_Gradient_01)',
  chart02Gradient02: 'url(#Chart_02_Gradient_02)',
  chart03Gradient01: 'url(#Chart_03_Gradient_01)',
  chart03Gradient02: 'url(#Chart_03_Gradient_02)',
  chart04Gradient01: 'url(#Chart_04_Gradient_01)',
  chart04Gradient02: 'url(#Chart_04_Gradient_02)',
  chart05Gradient01: 'url(#Chart_05_Gradient_01)',
  chart05Gradient02: 'url(#Chart_05_Gradient_02)',
  chart06Gradient01: 'url(#Chart_06_Gradient_01)',
  chart06Gradient02: 'url(#Chart_06_Gradient_02)',
  chartNEGGradient01: 'url(#Chart_NEG_Gradient_01)',
  chartNEGGradient02: 'url(#Chart_NEG_Gradient_02)',
  chartPOSGradient02: 'url(#Chart_POS_Gradient_02)',
} as const;
